import { ApplicationState } from '@app/store'
import {
  ICurrentUserState,
  selectCurrentUser,
} from '@app/store/modules/account'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { createStructuredSelector } from 'reselect'
import CityEditPage from '../components/CityEditPage'
import {
  actionCreators,
  ICityEditState,
  selectCanSave,
  selectCity,
} from '../modules/cityEdit'

type IComponentState = ICityEditState & ICurrentUserState

export default withRouter(
  connect(
    createStructuredSelector<ApplicationState, IComponentState>({
      canSave: selectCanSave(),
      city: selectCity(),
      user: selectCurrentUser(),
    }),
    actionCreators,
  )(CityEditPage),
)
